import { useEffect, useRef } from 'react';
import { stytchClient } from '../utils/stytch';
import { logAuthEvent } from '../utils/auth';
import { buildSafeHermetiqRedirectTarget } from '../utils/redirects';

// Login-origin logout endpoint (auth-dev.hermetiq.dev / auth.hermetiq.io).
//
// The dashboard runs behind oauth2-proxy and has no Stytch client, so
// oauth2-proxy's /oauth2/sign_out only clears the local proxy cookie. The Stytch
// SSO session (a ~30-day cookie on the parent domain) stays alive on this
// origin, so returning to the dashboard silently re-authenticates. oauth2-proxy
// therefore redirects here after clearing its cookie (this host is allow-listed
// via OAUTH2_PROXY_WHITELIST_DOMAINS); we revoke the Stytch session and then send
// the browser back to the dashboard, where the now-missing proxy cookie forces a
// fresh login.
export default function StytchLogoutPage() {
  const startedRef = useRef(false);

  useEffect(() => {
    // React StrictMode invokes effects twice in development; revoke once.
    if (startedRef.current) return;
    startedRef.current = true;

    const params = new URLSearchParams(window.location.search);
    const target = buildSafeHermetiqRedirectTarget(params.get('rd'), '/');
    logAuthEvent('logout:login-origin-start', { target });

    (async () => {
      try {
        if (stytchClient?.session?.revoke) {
          await stytchClient.session.revoke();
          logAuthEvent('logout:revoked-session', { reason: 'login_origin_logout' });
        }
      } catch (error) {
        console.warn('Failed to revoke Stytch session during logout', error);
      } finally {
        window.location.assign(target);
      }
    })();
  }, []);

  return <div className="logout-page">Signing you out&hellip;</div>;
}
